export const createValuesMap = <T extends string>(valueTypes: T[]): Record<T, boolean> => {
  return valueTypes.reduce((acc, curr) => {
    return { ...acc, [curr]: true }
  }, {} as Record<T, boolean>)
}
